import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { logout } from "../../store/authSlice";

const Logout: React.FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        const logoutUser = async () => {
            dispatch(logout())
        }
        setTimeout(() => {
            logoutUser()
        }, 2000);

    }, [])

    return (
        <div className="page-not-input">
            <h1 className="color">Signing you out securely</h1>
            <span className="text-spacing">Please wait while we complete your logout with Microsoft.</span>
        </div>
    )
}

export default Logout;